import _ from 'lodash';

import { fileLocal } from '~/data/local';
import { periodicCheckRemote } from '~/data/remote';
import { syncTypes } from '~/sqlite/syncDataTypes';
import store from '~/store';
import { PeriodicChecksPayload } from '~/types';

import { SyncHandlerOutcome, SyncTypeHandler } from './types';

export class PeriodicCheckSyncHandler implements SyncTypeHandler {
  readonly syncType = syncTypes.ADD_CHECK_PERIOD;

  async process(
    _row: unknown,
    requestData: Record<string, unknown>
  ): Promise<SyncHandlerOutcome> {
    const { payload, pathsToRemove } = await this.hydratePeriodicCheck(
      requestData as PeriodicChecksPayload
    );
    const response = await periodicCheckRemote.save(payload);

    if (response && response.success === false) {
      return {
        removeQueueRow: false,
        localFilePathsToDelete: [],
      };
    }

    if (requestData.machineId != null) {
      store.getActions().machine.clearPeriodicCheckPendingSync({
        machineId: String(requestData.machineId),
        inspectionType: Number(requestData.inspectionType),
      });
    }

    return {
      removeQueueRow: true,
      localFilePathsToDelete: pathsToRemove,
      machineIdToRefresh: requestData.machineId
        ? String(requestData.machineId)
        : undefined,
    };
  }

  private async hydratePeriodicCheck(requestData: PeriodicChecksPayload): Promise<{
    payload: PeriodicChecksPayload;
    pathsToRemove: string[];
  }> {
    const checks = Array.isArray(requestData.checks) ? requestData.checks : [];
    const pathsToRemove: string[] = [];
    const hydratedChecks = [];
    for (const check of checks) {
      const newImages = Array.isArray(check.newImages) ? (check.newImages as unknown[]) : [];
      const localPaths = newImages.filter(
        (image): image is string => _.isString(image) && !!image && !image.startsWith('http')
      );
      const keptImages = newImages.filter(
        (image) => !_.isString(image) || (image as string).startsWith('http')
      );
      let blobs: unknown[] = [];
      if (localPaths.length) {
        blobs = (await fileLocal.getBlobsFromURLs(localPaths)).filter(Boolean);
        localPaths.forEach((path) => pathsToRemove.push(path));
      }
      hydratedChecks.push({
        ...check,
        newImages: keptImages.concat(blobs),
      });
    }
    return {
      payload: { ...requestData, checks: hydratedChecks },
      pathsToRemove,
    };
  }
}

export const periodicCheckSyncHandler = new PeriodicCheckSyncHandler();
